import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface Cvp2ActiveConcern {
  id: number;
  name: string;
}

export interface GetCvp2ActiveConcernsResponse extends BackendResponse {
  items: Cvp2ActiveConcern[];
}

export interface GetCvp2ActiveConcernsParameters extends NextApiParams {}

export const getCvp2ActiveConcerns = withNextApi<
  GetCvp2ActiveConcernsResponse,
  GetCvp2ActiveConcernsParameters
>("/auth/GetCvp2ActiveConcerns", { method: "GET" });
